import { useEffect } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { DELETE_ALL_TEMP_SESSION } from '@mutations/tempHold'

const useTempHoldSessions = (ProgramId: string, holdDeletion: boolean = false) => {
  const deleteAllTempSessionByProgramId = (ProgramId: string) =>
    deleteAllTempSession({
      variables: {
        ProgramId,
      },
    })

  const [deleteAllTempSession, { loading }] = useMutation(DELETE_ALL_TEMP_SESSION)

  useEffect(() => {
    if (ProgramId && !holdDeletion) {
      deleteAllTempSessionByProgramId(ProgramId)
    }
  }, [ProgramId, holdDeletion])

  return {
    deleteAllTempSessionByProgramId,
    deletingAllTempSession: loading,
  }
}

export default useTempHoldSessions
